/* eslint-disable @next/next/no-img-element */
import { numberWithCommas, formatSku, getUrlName } from "utilities/helper";
import { IMG_URL } from "utilities/constants";

export default function SlideImage({ item, setTag, isRemove, isOld, isAdd }) {
    let imgUrl = '/images/icon-app.svg';
    let minimalPrice = null;
    let urlKey = '';

    if (item.custom_attributes) {
        const atributeImgUrl = item.custom_attributes.find(f => f.attribute_code == 'image');
        const atributeMinimalPrice = item.custom_attributes.find(f => f.attribute_code == 'minimal_price');
        imgUrl = atributeImgUrl ? IMG_URL + atributeImgUrl.value : '/images/icon-app.svg';
        minimalPrice = atributeMinimalPrice?.value || 0;

        const url_key = item.custom_attributes.find(f => f.attribute_code == 'url_key');
        urlKey = url_key?.value || '';
    }

    if (item.image) {
        imgUrl = item.image;
    }

    const link = urlKey ? `/shop/${formatSku(item.sku)}/${urlKey}.html` : `/shop/${formatSku(item.sku)}/${getUrlName(item.name || item.title)}.html`;

    return (<li>
        <div className="listSearch-thumb">
            <img src={imgUrl} alt="" />
        </div>
        <div className="listSearch-content">
            <h3 className="listSearch-title">
                <a target="_blank" href={link} rel="noreferrer">{item.name || item.title}</a>
            </h3>
            <div className="listSearch-view">
                <span className="view">{item?.extension_attributes?.rating_summary || item.rating_summary || ''}<img src="/images/icon-star.svg" alt="" /></span>
                <span className="products-priceNumber mr-1">đ{numberWithCommas(item.price || minimalPrice)}</span>
                {/* <span className="label"><img src="/images/icon-app.svg" alt="" />{item?.extension_attributes?.rating_summary}</span> */}
            </div>
            {isAdd && <button className="btn btn--blue" onClick={() => setTag(item)}>Chọn</button>}
            {isRemove && <button className="btn btn--red" onClick={() => setTag(item)}>Xóa</button>}
            {isOld && <button className="btn btn--red" onClick={() => setTag(item)}>Xóa</button>}
        </div>
    </li>
    );
};